
export const HandShakeConfig = {
    publicKey: "",
    handshakeUrl: "services/app/HandshakeService/Handshake",
    handshakeBaseUrl: "services/app/HandshakeService/Handshake",
    handshakeForAllRequest: true,
    pageIdHeader: "x-hs-page-id",
    captchaIdHeader: "x-card-pro-captcha-id",
};